import './CanceledProducts.scss'

import { Alert, Image, message, Table } from 'antd'
import { ColumnsType } from 'antd/es/table'

import { useSiparisDetayQuery } from '../../gql/GeneratedGraphqlTypes'
import { CanceledProductsItem } from './types'

interface Props {
  siparis: string
}

const CanceledProducts = ({ siparis }: Props) => {
  const temp = parseInt(siparis)
  const [messageApi] = message.useMessage()
  const { data, error } = useSiparisDetayQuery({
    variables: { siparis_id: temp },
  })
  if (error) {
    messageApi.error(`${error}`, 2)
  }
  if (!data) {
    return null
  }
  const rowClassName = (record: any, index: number) => {
    return record.durum === 'İptal' ? 'odd-row-cancelled' : 'even-row-cancelled'
  }
  const CanceledProductsItems: CanceledProductsItem[] =
    data?.siparisDetay.satirlar
      ?.filter((urun) => urun?.durum === 'İptal')
      .map((urun) => {
        return {
          key: urun?.id?.toString() || '', //Gerekli
          urun_isim: urun?.urun.isim || '',
          aciklamalar: urun?.urun.aciklamalar || '',
          adet: urun?.adet ?? 0,
          kalan_adet: urun?.kalan_adet ?? 0,
          birim_fiyat: parseFloat(`${urun?.birim_fiyat} â‚º` ?? '0'),
          kdv_dahil_fiyat: parseFloat(`${urun?.birim_fiyat} â‚º` ?? '0'),
          durum: urun?.durum || '',
          images: (urun?.urun.resimler as string[]) || [],
        }
      }) || []

  const columns: ColumnsType<CanceledProductsItem> = [
    {
      title: 'Ürün Adı',
      dataIndex: 'urun_isim',
      key: 'urun_isim',
      align: 'center',
      render: (text: string, record: CanceledProductsItem) => (
        <div className="order-product-cell">
          <Image src={record.images?.[0] ?? ''} alt={text} className="order-product-image" width={72} height={72} />
          <div className="product-name-wrapper">
            <span>{text}</span>
            {record.aciklamalar && <span className="product-aciklama"><span className="aciklama-label">Açıklama:</span> {record.aciklamalar}</span>}
          </div>
        </div>
      ),
    },
    {
      title: 'Adet',
      dataIndex: 'adet',
      key: 'adet',
      align: 'center',
    },
    {
      title: 'Kalan Adet',
      dataIndex: 'kalan_adet',
      key: 'kalan_adet',
      align: 'center',
    },
    {
      title: 'KDV Dahil Birim Fiyat',
      dataIndex: 'birim_fiyat',
      key: 'birim_fiyat',
      align: 'center',
    },
    {
      title: 'KDV Dahil Tutar',
      dataIndex: 'kdv_dahil_fiyat',
      key: 'kdv_dahil_fiyat',
      align: 'center',
    },
    {
      title: 'Durum',
      dataIndex: 'durum',
      key: 'durum',
      align: 'center',
    },
  ]

  return (
    <>
      <div className="cancalled-products-genel">
        <Alert
          className="custom-alert"
          description="İptal ettiğiniz ürünler listelenmektedir."
          type="success"
          closable
        />
        <br />
        <div className="cancelled-products">
          <Table columns={columns} dataSource={CanceledProductsItems} rowClassName={rowClassName} bordered={true} />
        </div>
      </div>
    </>
  )
}

export default CanceledProducts

